import { Box, Typography } from "@mui/material";
import { USER_ERROR_MESSAGE } from "../../../constants/errorMessages";

const NoDataFound = ({ height = 'calc(100vh - 540px)', message = USER_ERROR_MESSAGE.NO_DATA_FOUND }) => {    
    return (
        <Box sx={{ textAlign: 'center', paddingTop: '3vh', height: height }}>
            <Typography variant="h6" color="textSecondary">
                {message}
            </Typography>
        </Box>
);
}

export default NoDataFound;